import { SnackbarProps } from "@mui/material/Snackbar";
interface ISnackbarProps extends SnackbarProps {
  variant?: "error" | "success" | "warning" | "info" | "default";
}
class SnackbarUtils {
  #snackBar = {
    enqueueSnackbar: (msg: string, options: any) => { },
    closeSnackbar: (key: string) => { },
  };

  setSnackBar(enqueueSnackbar, closeSnackbar) {
    this.#snackBar.enqueueSnackbar = enqueueSnackbar;
    this.#snackBar.closeSnackbar = closeSnackbar;
  }

  success(msg, options: ISnackbarProps = {}) {
    return this.toast(msg, {
      ...options, variant: "success"
    });
  }
  warning(msg, options: ISnackbarProps = {}) {
    return this.toast(msg, { ...options, variant: "warning" });
  }
  info(msg, options: ISnackbarProps = {}) {
    return this.toast(msg, { ...options, variant: "info" });
  }

  error(msg, options: ISnackbarProps = {}) {
    return this.toast(msg, { ...options, variant: "error" });
  }
  toast(msg, options: ISnackbarProps = {}) {
    let key = Math.random().toString()
    const finalOptions: ISnackbarProps = {
      variant: "default",
      ...options,
      key,
      onClick: () => { this.closeSnackbar(key) }
    };
    return this.#snackBar.enqueueSnackbar(msg, { ...finalOptions });
  }
  closeSnackbar(key) {
    this.#snackBar.closeSnackbar(key);
  }
}
export default new SnackbarUtils();